<template>
  <div>
    <div class="card yellow">
      <div class="form-title">Mon programme de Menus</div>

      <div class="card light-yellow clickable" @click="downloadPdf">
        <div v-if="fetchingPDF" class="liked-dish-name">
          <Loader />
          Création du PDF en cours…
        </div>

        <div v-else class="liked-dish-name">
          <font-awesome-icon class="icon" :icon="['fas', 'file-pdf']" />
          Télécharger le PDF de mes menus de la semaine
        </div>
      </div>
      
      <p v-if="downloadError" class="download-error" role="alert">{{ downloadError }}</p>
      <p v-else class="download-hint">Ce bouton crée et télécharge un fichier PDF de vos menus de la semaine.</p>

      <a href="/recette-de-vinaigrette-maison" class="card-links">
        Recette de vinaigrette maison
      </a>
      <div class="d-flex gap-2">
        <button type="button" class="card-links" @click="showModalOne = true">
          Les boissons
        </button>

        <button type="button" class="card-links" @click="showModalTwo = true">
          Les condiments
        </button>
      </div>
    </div>

    <!-- Modale 1 -->
    <div v-if="showModalOne" class="modal-overlay" @click.self="showModalOne = false">
      <div class="simple-modal">
        <div class="simple-modal-header">
          <div class="simple-modal-title">Les Boissons</div>
          <button type="button" class="simple-modal-close" @click="showModalOne = false">
            ✕
          </button>
        </div>

        <div class="simple-modal-body">
          <p>
            L'eau, la meilleure des boissons, est à consommer à volonté. Si vous
            préférez éviter l’eau du robinet, privilégiez une eau locale
            (Wattwiller, Plancoët...) en bouteille consignée si possible.
          </p>
          <p>
            Le kéfir (de fruit ou de lait) ou le kombucha sont aussi recommandés
            pour leurs probiotiques. Ils nourrissent votre microbiote, tout
            comme les fibres de vos menus.
          </p>
          <p>
            Dans le cadre du régime méditerranéen, un verre de vin rouge bio par
            jour est envisageable, de préférence un pinot noir pour sa richesse
            en polyphénols.
          </p>
        </div>

        <div class="simple-modal-footer">
          <button type="button" class="simple-modal-btn" @click="showModalOne = false">
            Fermer
          </button>
        </div>
      </div>
    </div>

    <!-- Modale 2 -->
    <div v-if="showModalTwo" class="modal-overlay" @click.self="showModalTwo = false">
      <div class="simple-modal">
        <div class="simple-modal-header">
          <div class="simple-modal-title">Les condiments</div>
          <button type="button" class="simple-modal-close" @click="showModalTwo = false">
            ✕
          </button>
        </div>

        <div class="simple-modal-body">
          <p>Du sel avec modération. Herbes fraiches, aromates, ail, oignons ou épices à volonté !</p>
          <p>
            Pour réaliser Mes Meilleurs Menus au quotidien, nous recommandons de
            constituer une réserve d’épices et d’aromates : Les épices : cumin,
            cannelle, curcuma, curry, poivre, gingembre moulu, paprika, noix de
            muscade, clou de girofle. Les aromates : persil, basilic,
            ciboulette, aneth, herbes de Provence, origan, thym, cerfeuil,
            coriandre, romarin, ail, oignons, échalotes.
          </p>
        </div>

        <div class="simple-modal-footer">
          <button type="button" class="simple-modal-btn" @click="showModalTwo = false">
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import Loader from "@/components/Loader.vue";

export default {
  name: "MyPdf",
  components: { Loader },
  data() {
    return {
      fetchingPDF: false,
      downloadError: "",
      showModalOne: false,
      showModalTwo: false,
    };
  },

  mounted() {
    const params = new URLSearchParams(window.location.search);
    const ouvre = (params.get("ouvre") || "").toLowerCase();

    if (ouvre === "boisson") {
      this.showModalOne = true;
    } else if (ouvre === "condiments") {
      this.showModalTwo = true;
    }
  },

  methods: {
    async downloadPdf() {
      if (this.fetchingPDF) return;

      this.fetchingPDF = true;
      this.downloadError = "";

      try {
        const response = await api.get("my-pdf/", { responseType: "blob" });
        const blob = new Blob([response.data], { type: "application/pdf" });

        let filename = "menus-de-la-semaine.pdf";
        const dispo =
          response.headers["content-disposition"] ||
          response.headers["Content-Disposition"];

        if (dispo && dispo.indexOf("filename=") !== -1) {
          const match = dispo.match(/filename="?([^"]+)"?/);
          if (match && match[1]) filename = match[1];
        }

        const fileURL = window.URL.createObjectURL(blob);
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", filename);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        window.setTimeout(() => window.URL.revokeObjectURL(fileURL), 1000);
      } catch (error) {
        this.downloadError = "Impossible de créer le PDF de vos menus. Réessayez dans un instant.";
      } finally {
        this.fetchingPDF = false;
      }
    },
  },
};
</script>

<style scoped>
.download-hint {
  margin: 8px 4px 0;
  text-align: center;
  color: #4b5734;
  font-size: 14px;
}

.download-error {
  margin: 10px 4px 0;
  color: #9b2c2c;
  font-size: 14px;
  text-align: center;
}

.liked-dish-name {
  font-size: 20px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 10px;
}

.card-links {
  font-size: 20px;
  font-weight: bold;
  color: #000;
  text-align: center;
  box-shadow: 5px 5px 25px rgba(0, 0, 0, 0.3);
  background-color: #fcf5ba;
  padding: 16px;
  border-radius: 18px;
  margin-top: 20px;
  display: block;
  width: 100%;
  border: none;
  cursor: pointer;
}

.card-links:hover {
  text-decoration: none;
}

/* Overlay centré */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
}

/* IMPORTANT : pas "modal" (Bootstrap), mais "simple-modal" */
.simple-modal {
  width: 100%;
  max-width: 560px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.35);
  overflow: hidden;
}

.simple-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.simple-modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #000;
}

.simple-modal-close {
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
}

.simple-modal-body {
  padding: 16px;
  color: #000;
  font-size: 16px;
}

.simple-modal-footer {
  padding: 14px 16px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.simple-modal-btn {
  border: none;
  border-radius: 12px;
  padding: 10px 14px;
  cursor: pointer;
}
</style>
